import api from '../../api/client';
import React, { useEffect, useState } from 'react'
import { useSetRecoilState } from 'recoil'
import Contractors from '../../components/department/Contractors'
import ContractorSearch from '../../components/department/ContractorsSearch'
import Layout from '../../components/layout/Layout'
import { loadingState } from '../../recoil/atoms'
import { contractorsState } from './atoms'

const ContractorsList = () => {
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const [search, setSearch] = useState('')
    const setContractors = useSetRecoilState(contractorsState)
    const setLoading = useSetRecoilState(loadingState)
    useEffect(() => {
        setLoading(true)
        api.get('users/contractors/' + rowsPerPage + '/' + (page + 1) + '/' + search).then(result => {
            setContractors(result.data)
            setLoading(false)
        })
    }, [page, rowsPerPage, search, setContractors, setLoading])
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }
    return (
        <Layout>
            <ContractorSearch
                setSearch={setSearch}
            />
            <Contractors
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Layout>
    )
}
export default ContractorsList